import { render, staticRenderFns } from "./roleAuthority.vue?vue&type=template&id=70ae004e&scoped=true&"
import script from "./roleAuthority.vue?vue&type=script&lang=js&"
export * from "./roleAuthority.vue?vue&type=script&lang=js&"
import style0 from "./roleAuthority.vue?vue&type=style&index=0&id=70ae004e&lang=less&scoped=true&"
import style1 from "./roleAuthority.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae004e",
  null
  
)

export default component.exports